import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { TopCommandBar } from './TopCommandBar';

export default function DashboardLayout() {
  return (
    <div className="flex min-h-screen bg-surface-base text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopCommandBar />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1600px] px-4 py-6 md:px-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
